import { render, staticRenderFns } from "./LowbalanceReport.vue?vue&type=template&id=5beb0d38"
import script from "./LowbalanceReport.vue?vue&type=script&lang=js"
export * from "./LowbalanceReport.vue?vue&type=script&lang=js"
import style0 from "./LowbalanceReport.vue?vue&type=style&index=0&id=5beb0d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports